var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Allow, IsDate, IsDefined, IsIn, IsInt, IsUUID, Max, Min, MinLength, } from "class-validator";
import { plainToInstance, Type } from "class-transformer";
import { Default, ExcludeFrontend, ExposeFrontend } from "../../decorators";
import { DEPARTMENT_LIST } from "../../constants";
import { BaseDTO } from "../public";
export class ReviewDTO extends BaseDTO {
    constructor() {
        super(...arguments);
        this.postDate = new Date();
    }
}
__decorate([
    IsUUID(),
    ExposeFrontend(),
    Default(() => crypto.randomUUID())
], ReviewDTO.prototype, "id", void 0);
__decorate([
    IsUUID(),
    ExcludeFrontend()
], ReviewDTO.prototype, "professor", void 0);
__decorate([
    IsDefined(),
    ExposeFrontend()
], ReviewDTO.prototype, "grade", void 0);
__decorate([
    IsDefined(),
    ExposeFrontend()
], ReviewDTO.prototype, "gradeLevel", void 0);
__decorate([
    IsDefined(),
    ExposeFrontend()
], ReviewDTO.prototype, "courseType", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    Default(() => new Date()),
    ExposeFrontend()
], ReviewDTO.prototype, "postDate", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4),
    ExcludeFrontend()
], ReviewDTO.prototype, "overallRating", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4),
    ExcludeFrontend()
], ReviewDTO.prototype, "presentsMaterialClearly", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(4),
    ExcludeFrontend()
], ReviewDTO.prototype, "recognizesStudentDifficulties", void 0);
__decorate([
    MinLength(20),
    ExposeFrontend()
], ReviewDTO.prototype, "rating", void 0);
export class PendingReviewDTO extends ReviewDTO {
    static fromAddReviewRequest(request) {
        return plainToInstance(PendingReviewDTO, request);
    }
    toReviewDTO() {
        return plainToInstance(ReviewDTO, this, {
            excludeExtraneousValues: true,
        });
    }
}
__decorate([
    Allow(),
    ExcludeFrontend(),
    Default(() => "Queued")
], PendingReviewDTO.prototype, "status", void 0);
__decorate([
    Allow(),
    ExposeFrontend()
], PendingReviewDTO.prototype, "error", void 0);
__decorate([
    Allow(),
    ExposeFrontend()
], PendingReviewDTO.prototype, "sentimentResponse", void 0);
__decorate([
    IsInt(),
    Min(100),
    Max(599),
    ExposeFrontend()
], PendingReviewDTO.prototype, "courseNum", void 0);
__decorate([
    IsIn(DEPARTMENT_LIST),
    ExposeFrontend()
], PendingReviewDTO.prototype, "department", void 0);
//# sourceMappingURL=Reviews.js.map